import { colors } from "@quickpoint.me/shared";
import styled from "styled-components";

const StyledBCError = styled.div`
    height: 100%;
    width: 100%;
    background-color: ${colors.brand.blue};
    color: black;
    font-family:courier, courier new, serif;
`;

function BCError() {
    return (
        <StyledBCError>
            Your browser does not support Broadcast Channels. These are required for this app to work. Sorry for the
            inconvenience. Supported browsers include:
            <ul>
                <li>Chrome. Version 54 onwards</li>
                <li>Chrome for Android. Version 99 onwards</li>
                <li>Edge. Version 79 onwards</li>
                <li>Firefox. Version 38 onwards</li>
                <li>Safari. Version 15.4 onwards</li>
            </ul>
        </StyledBCError>
    );
}

export default BCError;
